import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Heading"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "heading"
    }}>{`Heading`}</h1>
    <p>{`Primitive heading component, defaults to `}<inlineCode parentName="p">{`<h2>`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { Heading } from 'theme-ui'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Heading>Hello</Heading>
<Heading as='h3'>Subhead</Heading>
`}</code></pre>
    <p>{`Use the `}<inlineCode parentName="p">{`as`}</inlineCode>{` prop to set the correct HTML element independent from styling.`}</p>
    <h2 {...{
      "id": "variants"
    }}>{`Variants`}</h2>
    <p>{`Text style variants can be defined in the `}<inlineCode parentName="p">{`theme.text`}</inlineCode>{` object.
The Heading component uses `}<inlineCode parentName="p">{`theme.text.heading`}</inlineCode>{` as its default variant style.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// example theme variants
{
  text: {
    caps: {
      textTransform: 'uppercase',
      letterSpacing: '0.2em',
    },
    heading: {
      fontFamily: 'heading',
      fontWeight: 'heading',
      lineHeight: 'heading',
    },
  }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      